import { SquareCheck } from 'lucide-react';
import { CustomFieldDefinition } from '__types__';
import { FilterBooleanConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createBooleanFilterConfig(
  customFieldDef: CustomFieldDefinition
): FilterBooleanConfig {
  return {
    label: customFieldDef.name,
    icon: <SquareCheck />,
    type: 'boolean' as const,
    createDefaultValue: () => ({ operator: 'equal', value: false }),
    options: {
      valueLabel: 'True',
      subjectLabel: customFieldDef.name
    }
  };
}
